module.exports = __webpack_public_path__ + "static/img/p_3_11.ae46d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p_3_11.jpg
// module id = p8yI
// module chunks = 1